import { useEffect, useCallback } from "react";
import { SiteBody } from "@vviinn/user-managment-client-ts";
import { generatePath, Params, useMatch, useNavigate } from "react-router";

import { useAppSelector } from "../../store";

const applyPathException = (path: string) =>
  path.includes("campaigns/new") || path.includes("campaign/")
    ? `${path.split("campaign")[0]}campaigns`
    : path;

export const useSiteSelect = () => {
  const navigate = useNavigate();

  const isSiteState = useMatch("/company/:companyId/site/:siteId/*");

  const selectedSiteId = useAppSelector((state) => state.site?.id);
  const selectedCompanyId = useAppSelector(
    (state) => state.company.company?.id,
  );

  const redirectSite = useCallback(
    (id: SiteBody["id"]) => {
      if (!id || !isSiteState) return;
      const { params, pattern } = isSiteState;
      const newParams = {
        ...params,
        siteId: `${id}`,
      } as Params<string>;
      const newPath = applyPathException(generatePath(pattern.path, newParams));
      navigate(newPath, { replace: true });
    },
    [isSiteState, navigate, selectedSiteId],
  );

  useEffect(() => {
    if (!selectedSiteId || !selectedCompanyId) return;
    redirectSite(selectedSiteId);
  }, [selectedSiteId]);
};
